import type { AxiosResponse } from 'axios';
import type { SortDirection } from 'tabulator-tables';

export type BaseResponse<T> = {
  status: ResponseStatus;
  payload: T;
  additionalInformation: string | null;
};

export type ResponseStatus = {
  message: string;
  code: number;
};

export type ErrorResponse<T> = {
  additionalInformation: string | null;
  payload: T | null;
  status: ResponseStatus;
};

export type AxiosErrorResponseData<T> = ErrorResponse<T> & {
  message: string;
  code: number;
  errors: ResponseStatus[];
};

export type PaginatedRequest = {
  perPage: number;
  page: number;
  sortBy?: string;
  sortDesc?: SortDirection;
};

export type SortConfig = {
  sortBy: string;
  sortDesc: SortDirection;
};

export type RequestMethod = 'get' | 'post' | 'patch' | 'put' | 'delete';

export type RouteWithoutAuthorization = {
  route: RegExp;
  method?: RequestMethod;
};

export enum RequestStatus {
  ERROR = 0,
  SUCCESS = 1
}

export type ApiResponse<T> = SuccessApiResponse<T> | ErrorApiResponse<T>;
export type DownloadResponse<T> = SuccessDownloadResponse<T> | ErrorApiResponse<T>;

export type MappedResponse<T> = MappedSuccessResponse<T> | MappedErrorResponse;

export type MappedSuccessResponse<T> = {
  status: RequestStatus.SUCCESS;
  data: T;
};
export type MappedErrorResponse = {
  status: RequestStatus.ERROR;
  data: null;
};

export type SuccessApiResponse<T> = {
  status: RequestStatus.SUCCESS;
  data: T;
  error: null;
  networkResponse: AxiosResponse<BaseResponse<T>>;
};

export type SuccessDownloadResponse<T> = {
  status: RequestStatus.SUCCESS;
  data: T;
  error: null;
  networkResponse: AxiosResponse<T>;
};

export type ErrorApiResponse<T> = {
  status: RequestStatus.ERROR;
  data: null;
  error: ErrorResponse<T>;
  networkResponse: null;
};
